import { useEffect, useState } from "react";
import { Banknote, Percent, Wallet, CarTaxiFront, Star } from "lucide-react";
import { StatCard } from "@/components/StatCard";
import { StatusBadge } from "@/components/StatusBadge";
import { DataTable } from "@/components/fleet/DataTable";
import { api, kina } from "@/lib/api";

export const Earnings = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/driver/earnings").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return <div className="h-64 animate-pulse rounded-2xl bg-white" />;
  const t = data.today;
  return (
    <div className="space-y-8">
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
        <StatCard testId="driver-rating" label="Your rating" value={data.rating.avg ? `${data.rating.avg.toFixed(1)} ★` : "—"} icon={Star} hint={`${data.rating.count} passenger ratings`} />
        <StatCard testId="driver-today-trips" label="Trips today" value={t.trips} icon={CarTaxiFront} />
        <StatCard testId="driver-today-gross" label="Cash collected today" value={kina(t.gross)} icon={Banknote} />
        <StatCard testId="driver-today-fee" label={`Platform fee (${data.fee_pct}%)`} value={kina(t.driver_fee)} icon={Percent} hint="Payable to platform daily" />
        <StatCard testId="driver-today-net" label="Your take-home" value={kina(t.driver_net)} icon={Wallet} tone="dark" />
      </div>
      <DataTable
        testId="driver-earnings-table"
        rows={data.days}
        empty="Complete your first trip to see daily earnings."
        cols={[
          ["Date", (r) => r.date],
          ["Trips", (r) => r.trips],
          ["Gross", (r) => kina(r.gross)],
          ["Fee", (r) => kina(r.driver_fee)],
          ["Net", (r) => <b>{kina(r.driver_net)}</b>],
          ["Fee status", (r) => <StatusBadge status={r.settled ? "settled" : "unsettled"} />],
        ]}
      />
    </div>
  );
};
